module.exports = __webpack_public_path__ + "static/img/23.29b3591.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/23.png
// module id = a7cO
// module chunks = 1